const handleModalTitle = (columnTitle, isRecruiter) => {
  switch (columnTitle) {
    case "phone-interview":
      if (isRecruiter) {
        return "Phone Interview";
      }
      return "Request Phone Interview";
    case "first-interview":
      if (isRecruiter) {
        return `First face to face Interview`;
      }
      return "Request First face to face Interview";
    case "second-interview":
      if (isRecruiter) {
        return "Second face to face Interview";
      }
      return "Request Second face to face Interview";
    case "competencies":
      if (isRecruiter) {
        return "Completed Competencies";
      }
      return "Request Competencies";
    case "make-offer":
      if (isRecruiter) {
        return "Job Offer";
      }
      return "Make a Job Offer";
    case "job-offer":
      if (isRecruiter) {
        return "Job Offer";
      }
      return "Make a Job Offer";
    default:
      if (isRecruiter) {
        return "Withdraw Candidate";
      }
      return "Reject Candidate";
  }
};

export { handleModalTitle as default };
